function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsCheck } from '@deephaven/icons';
import { TimeUtils } from '@deephaven/utils';
import classNames from 'classnames';
import TimeInput from "./TimeInput.js";
import DropdownMenu from "./menu-actions/DropdownMenu.js";
import "./CustomTimeSelect.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CUSTOM_OPTION = -1;
var MENU_NAVIGATION_DIRECTION = /*#__PURE__*/function (MENU_NAVIGATION_DIRECTION) {
  MENU_NAVIGATION_DIRECTION["UP"] = "UP";
  MENU_NAVIGATION_DIRECTION["DOWN"] = "DOWN";
  return MENU_NAVIGATION_DIRECTION;
}(MENU_NAVIGATION_DIRECTION || {});
class CustomTimeSelect extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "csContainer", void 0);
    _defineProperty(this, "menuContainer", void 0);
    _defineProperty(this, "button", void 0);
    _defineProperty(this, "input", void 0);
    var value = props.value,
      valueToTime = props.valueToTime;
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleMenuKeyDown = this.handleMenuKeyDown.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleOptionFocus = this.handleOptionFocus.bind(this);
    this.handleMenuOpened = this.handleMenuOpened.bind(this);
    this.handleMenuExited = this.handleMenuExited.bind(this);
    this.handleCustomInput = this.handleCustomInput.bind(this);
    this.csContainer = /*#__PURE__*/React.createRef();
    this.menuContainer = /*#__PURE__*/React.createRef();
    this.button = /*#__PURE__*/React.createRef();
    this.input = /*#__PURE__*/React.createRef();
    this.state = {
      keyboardOptionIndex: 0,
      menuIsOpen: false,
      inputWidth: 100,
      customTime: valueToTime(value),
      inputFocused: false
    };
  }
  getSelectedText() {
    var _this$props = this.props,
      options = _this$props.options,
      value = _this$props.value,
      placeholder = _this$props.placeholder;
    var customTime = this.state.customTime;
    if (value === null) {
      return placeholder;
    }
    for (var i = 0; i < options.length; i += 1) {
      var option = options[i];
      if (option.value === value) {
        return option.title;
      }
    }
    return TimeUtils.formatTime(customTime);
  }
  setInputWidth() {
    if (this.csContainer.current) {
      this.setState({
        inputWidth: this.csContainer.current.getBoundingClientRect().width
      });
    }
  }
  focus() {
    var _this$button$current;
    (_this$button$current = this.button.current) === null || _this$button$current === void 0 || _this$button$current.focus();
  }
  updateInputValue(value) {
    var onChange = this.props.onChange;
    onChange(value);
  }
  handleResize() {
    this.setInputWidth();
  }
  handleMenuKeyDown(event) {
    var _this$button$current2;
    var _this$state = this.state,
      keyboardOptionIndex = _this$state.keyboardOptionIndex,
      inputFocused = _this$state.inputFocused;
    var options = this.props.options;
    switch (event.key) {
      case 'Enter':
      case ' ':
        // Space Bar
        if (inputFocused) {
          this.updateFromCustom();
        } else {
          this.updateInputValue(options[keyboardOptionIndex].value);
        }
        this.closeMenu();
        (_this$button$current2 = this.button.current) === null || _this$button$current2 === void 0 || _this$button$current2.focus();
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'Tab':
        if (event.shiftKey) {
          this.handleMenuNavigation(CustomTimeSelect.MENU_NAVIGATION_DIRECTION.UP);
        } else {
          this.handleMenuNavigation(CustomTimeSelect.MENU_NAVIGATION_DIRECTION.DOWN);
        }
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'ArrowUp':
        this.handleMenuNavigation(CustomTimeSelect.MENU_NAVIGATION_DIRECTION.UP);
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'ArrowDown':
        this.handleMenuNavigation(CustomTimeSelect.MENU_NAVIGATION_DIRECTION.DOWN);
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'Escape':
        this.closeMenu();
        break;
      default:
        break;
    }
  }
  handleMenuNavigation(direction) {
    var _this$state2 = this.state,
      keyboardOptionIndex = _this$state2.keyboardOptionIndex,
      inputFocused = _this$state2.inputFocused;
    var options = this.props.options;
    var menuOptionsLength = options.length;
    var newKeyboardOptionIndex = keyboardOptionIndex;
    switch (direction) {
      case CustomTimeSelect.MENU_NAVIGATION_DIRECTION.UP:
        if (!inputFocused && keyboardOptionIndex === 0) {
          this.focusInput();
          break;
        } else if (inputFocused) {
          this.focusOption(keyboardOptionIndex);
        }
        if (keyboardOptionIndex > 0 && !inputFocused) {
          newKeyboardOptionIndex = (newKeyboardOptionIndex - 1) % menuOptionsLength;
          this.setState({
            keyboardOptionIndex: newKeyboardOptionIndex
          });
        } else if (keyboardOptionIndex === 0) {
          newKeyboardOptionIndex = menuOptionsLength - 1;
          this.setState({
            keyboardOptionIndex: newKeyboardOptionIndex
          });
        }
        this.scrollOptionIntoView(newKeyboardOptionIndex);
        break;
      case CustomTimeSelect.MENU_NAVIGATION_DIRECTION.DOWN:
        if (!inputFocused && keyboardOptionIndex === menuOptionsLength - 1) {
          this.focusInput();
          break;
        } else if (inputFocused) {
          this.focusOption(keyboardOptionIndex);
        }
        if (keyboardOptionIndex < menuOptionsLength && !(inputFocused && keyboardOptionIndex === 0)) {
          newKeyboardOptionIndex = (newKeyboardOptionIndex + 1) % menuOptionsLength;
          this.setState({
            keyboardOptionIndex: newKeyboardOptionIndex
          });
        }
        this.scrollOptionIntoView(newKeyboardOptionIndex);
        break;
      default:
        break;
    }
  }
  handleOptionClick(event) {
    var optionIndex = Number(event.currentTarget.value);
    var _this$props2 = this.props,
      options = _this$props2.options,
      timeToValue = _this$props2.timeToValue;
    var customTime = this.state.customTime;
    if (optionIndex === CUSTOM_OPTION) {
      var update = timeToValue(customTime);
      this.updateAndClose(update);
    } else {
      this.updateAndClose(options[optionIndex].value);
    }
  }
  updateAndClose(update) {
    var _this$button$current3;
    this.updateInputValue(update);
    this.closeMenu();
    (_this$button$current3 = this.button.current) === null || _this$button$current3 === void 0 || _this$button$current3.focus();
  }
  handleOptionFocus(event) {
    this.setState({
      keyboardOptionIndex: Number(event.target.value)
    });
  }
  handleMenuOpened() {
    var _this$menuContainer$c;
    var _this$props3 = this.props,
      options = _this$props3.options,
      value = _this$props3.value;
    var keyboardOptionIndex = this.state.keyboardOptionIndex;
    this.scrollOptionIntoView(keyboardOptionIndex);
    var activeOption = (_this$menuContainer$c = this.menuContainer.current) === null || _this$menuContainer$c === void 0 ? void 0 : _this$menuContainer$c.querySelector('.cs-option-btn.keyboard-active');
    if (activeOption instanceof HTMLElement) {
      activeOption.focus();
    }
    if (value === null) {
      return;
    }
    var valueIndex = options.map(option => option.value).indexOf(value);
    if (valueIndex < 0) {
      // The custom option should be selected
      this.focusInput();
    }
  }
  focusInput() {
    var _this$input$current;
    (_this$input$current = this.input.current) === null || _this$input$current === void 0 || _this$input$current.focus();
  }
  focusOption(index) {
    var _this$menuContainer$c2;
    var options = (_this$menuContainer$c2 = this.menuContainer.current) === null || _this$menuContainer$c2 === void 0 ? void 0 : _this$menuContainer$c2.querySelector('.cs-options');
    if (options && options.children != null) {
      var option = options.children.item(index);
      if (option instanceof HTMLElement) {
        option.focus();
      }
    }
  }
  handleMenuExited() {
    var menuIsOpen = this.state.menuIsOpen;
    if (menuIsOpen) {
      this.setState({
        menuIsOpen: false,
        keyboardOptionIndex: 0
      });
    }
  }
  handleCustomInput(value) {
    var timeToValue = this.props.timeToValue;
    var update = timeToValue(value);
    this.updateInputValue(update);
    this.setState({
      customTime: value
    });
  }
  updateFromCustom() {
    var timeToValue = this.props.timeToValue;
    var customTime = this.state.customTime;
    var update = timeToValue(customTime);
    this.updateInputValue(update);
  }
  toggleMenu(event) {
    var menuIsOpen = this.state.menuIsOpen;
    if (menuIsOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
    event.stopPropagation();
  }
  openMenu() {
    this.updateKeyboardIndex();
    this.setInputWidth();
    this.setState({
      menuIsOpen: true
    });
  }
  closeMenu() {
    var focusButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.setState({
      menuIsOpen: false
    });
    if (focusButton) {
      var _this$button$current4;
      (_this$button$current4 = this.button.current) === null || _this$button$current4 === void 0 || _this$button$current4.focus();
    }
  }
  updateKeyboardIndex() {
    var _this$props4 = this.props,
      options = _this$props4.options,
      value = _this$props4.value;
    if (value === null) {
      return;
    }
    var valueIndex = options.map(option => option.value).indexOf(value);
    if (valueIndex > 0) {
      this.setState({
        keyboardOptionIndex: valueIndex
      });
    }
  }
  scrollOptionIntoView(index) {
    var _this$menuContainer$c3;
    var options = (_this$menuContainer$c3 = this.menuContainer.current) === null || _this$menuContainer$c3 === void 0 ? void 0 : _this$menuContainer$c3.querySelector('.cs-options');
    if (options && options.children != null) {
      var activeOption = options.children.item(index);
      if (activeOption instanceof HTMLElement && activeOption.offsetTop > CustomTimeSelect.DROP_DOWN_MENU_HEIGHT) {
        options.scrollTop = activeOption.offsetTop - CustomTimeSelect.DROP_DOWN_MENU_HEIGHT;
      } else if (activeOption instanceof HTMLElement && activeOption.offsetTop < 0 || index === 0) {
        options.scrollTop = 0;
      }
    }
  }
  renderMenuElement() {
    var inputWidth = this.state.inputWidth;
    return /*#__PURE__*/_jsx("div", {
      className: "cs-menu-container",
      ref: this.menuContainer,
      role: "presentation",
      onKeyDown: this.handleMenuKeyDown,
      onClick: event => {
        event.stopPropagation();
      },
      style: {
        width: inputWidth
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "cs-options-container",
        children: /*#__PURE__*/_jsx("div", {
          className: "cs-options",
          children: this.renderOptions()
        })
      })
    });
  }
  renderOptions() {
    var _this$props5 = this.props,
      options = _this$props5.options,
      value = _this$props5.value,
      icon = _this$props5.icon,
      customText = _this$props5.customText;
    var _this$state3 = this.state,
      keyboardOptionIndex = _this$state3.keyboardOptionIndex,
      customTime = _this$state3.customTime,
      inputFocused = _this$state3.inputFocused;
    var matchFound = false;
    var optionArray = [];
    for (var index = 0; index < options.length; index += 1) {
      var option = options[index];
      var key = "option-".concat(index, "-").concat(option.value);
      matchFound = matchFound || option.value === value;
      optionArray.push(/*#__PURE__*/_jsxs("button", {
        type: "button",
        value: index,
        className: classNames('cs-option-btn', {
          'keyboard-active': keyboardOptionIndex === index && !inputFocused
        }),
        onClick: this.handleOptionClick,
        onFocus: this.handleOptionFocus,
        children: [option.value === value && /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: icon,
          className: "mr-2"
        }), option.value !== value && /*#__PURE__*/_jsx("span", {
          className: "mr-4"
        }), option.title]
      }, key));
    }
    optionArray.push(/*#__PURE__*/_jsx("hr", {
      className: "cs-divider"
    }, "option-divider"));
    optionArray.push(/*#__PURE__*/_jsxs("button", {
      type: "button",
      value: CUSTOM_OPTION,
      className: classNames('cs-option-btn', {
        'keyboard-active': inputFocused
      }),
      onClick: this.handleOptionClick,
      onFocus: this.handleOptionFocus,
      children: [!matchFound && value !== null ? /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: icon,
        className: "mr-2"
      }) : /*#__PURE__*/_jsx("span", {
        className: "mr-4"
      }), customText]
    }, "option-custom-label"));
    optionArray.push(/*#__PURE__*/_jsxs("div", {
      className: "cs-custom-container",
      children: [/*#__PURE__*/_jsx("span", {
        className: "mr-2"
      }), /*#__PURE__*/_jsx(TimeInput, {
        ref: this.input,
        onChange: this.handleCustomInput,
        value: customTime,
        onFocus: () => this.setState({
          inputFocused: true
        }),
        onBlur: () => this.setState({
          inputFocused: false
        })
      }, "option-input"), /*#__PURE__*/_jsx("span", {
        className: "ml-2"
      })]
    }, "cs-custom-container"));
    optionArray.push(/*#__PURE__*/_jsx("hr", {
      className: "mb-2"
    }, "option-end"));
    return optionArray;
  }
  render() {
    var _this$props6 = this.props,
      disabled = _this$props6.disabled,
      invalid = _this$props6.invalid,
      value = _this$props6.value,
      dataTestId = _this$props6['data-testid'];
    var menuIsOpen = this.state.menuIsOpen;
    var popperOptions = this.props.popperOptions;
    popperOptions = _objectSpread({
      placement: 'bottom-end',
      modifiers: {
        preventOverflow: {
          enabled: false
        }
      }
    }, popperOptions);
    return /*#__PURE__*/_jsx("div", {
      className: "input-group cs-container context-menu",
      ref: this.csContainer,
      "data-testid": dataTestId,
      children: /*#__PURE__*/_jsx("div", {
        className: classNames('input-group-append cs-dropdown', {
          'cs-dropdown-invalid': invalid
        }),
        children: /*#__PURE__*/_jsxs("button", {
          type: "button",
          className: classNames('btn cs-btn form-control', {
            'cs-btn-invalid': invalid
          }),
          ref: this.button,
          onClick: this.toggleMenu,
          disabled: disabled,
          children: [/*#__PURE__*/_jsx("span", {
            className: classNames({
              'text-muted': value === null
            }),
            children: this.getSelectedText()
          }), /*#__PURE__*/_jsx("span", {
            className: "cs-caret"
          }), /*#__PURE__*/_jsx(DropdownMenu, {
            isShown: menuIsOpen,
            actions: {
              menuElement: this.renderMenuElement()
            },
            popperOptions: popperOptions,
            popperClassName: "CustomTimeSelect",
            onMenuOpened: this.handleMenuOpened,
            onMenuClosed: this.handleMenuExited,
            menuStyle: {
              maxWidth: '100rem'
            }
          })]
        })
      })
    });
  }
}
_defineProperty(CustomTimeSelect, "MENU_NAVIGATION_DIRECTION", MENU_NAVIGATION_DIRECTION);
_defineProperty(CustomTimeSelect, "DROP_DOWN_MENU_HEIGHT", 125);
_defineProperty(CustomTimeSelect, "defaultProps", {
  onChange() {
    // no-op
  },
  value: null,
  disabled: false,
  popperOptions: {},
  icon: vsCheck,
  customText: 'Custom',
  placeholder: 'Select a time',
  valueToTime: value => value === null ? 0 : Math.round(value / 1000),
  timeToValue: time => time * 1000,
  invalid: false,
  'data-testid': undefined
});
export default CustomTimeSelect;
//# sourceMappingURL=CustomTimeSelect.js.map